module.exports = __webpack_public_path__ + "static/media/matapelajaran.ebf64491.png";